export { SSRProvider } from '@sberdevices/plasma-core';
